import { CoreHelperUtil } from '@reown/appkit';
import { ConstantsUtil } from '@reown/appkit-common';
import { ANALYTICS_EVENTS, ANALYTICS_SDK_TYPE } from '../Constants';
// Sends metering events to Pulse, separately from AppKit's own analytics pipeline
export class AnalyticsController {
    appKit;
    analyticsUrl;
    constructor(appKit, analyticsUrl) {
        this.appKit = appKit;
        // `||` not `??`: an env var declared with no value arrives as an empty string,
        // and an empty base would throw on every event rather than falling back
        this.analyticsUrl = analyticsUrl || ConstantsUtil.PULSE_API_URL;
    }
    sendWebWalletAuthenticated({ appProjectId, address, accounts, user }) {
        if (typeof window === 'undefined' || typeof navigator?.sendBeacon !== 'function')
            return;
        try {
            // Pulse reads the projectId on the request url as the sender's identity, so that one
            // stays the Web Wallet's own and the app's travels in the event properties
            const url = new URL('/batch', this.analyticsUrl);
            url.searchParams.set('projectId', this.appKit.options.projectId);
            url.searchParams.set('st', ANALYTICS_SDK_TYPE);
            url.searchParams.set('sv', this.appKit.version);
            const events = [
                {
                    eventId: CoreHelperUtil.getUUID(),
                    // Origin and path only. The /wc query string carries the pairing uri, and that
                    // holds the symmetric key for the pairing, which has no business in an event.
                    url: `${window.location.origin}${window.location.pathname}`,
                    domain: window.location.hostname,
                    timestamp: Date.now(),
                    props: {
                        type: 'track',
                        event: ANALYTICS_EVENTS.WEB_WALLET_AUTHENTICATED,
                        address,
                        properties: {
                            appProjectId,
                            accounts,
                            loginProvider: user.loginProvider,
                            email: user.email,
                            username: user.username
                        }
                    }
                }
            ];
            const queued = navigator.sendBeacon(url.toString(), JSON.stringify(events));
            if (!queued) {
                console.warn('[AnalyticsController] Browser refused to queue the authenticated event');
            }
        }
        catch (err) {
            console.error('[AnalyticsController] Failed to send Web Wallet Authenticated event:', err);
        }
    }
}
//# sourceMappingURL=AnalyticsController.js.map